/**
 * Kaiverruspalvelu - Tuotesivun toiminnallisuus
 * 
 * HUOM: Kaiverrustuotteen ID kovakoodattu
 * Product ID: 10353084006733
 * Variant ID: 52708460396877
 */
class ProductEngraving {
  constructor() {
    console.log('ProductEngraving: Constructor käynnistyy');
    
    this.ENGRAVING_VARIANT_ID = 52708460396877;
    
    this.engravingCheckbox = document.getElementById('engraving-checkbox');
    this.engravingTextWrapper = document.querySelector('.engraving-text-wrapper');
    this.engravingTextInput = document.getElementById('engraving-text');
    this.productForm = document.querySelector('form[action*="/cart/add"]');
    
    // Etsi Add to Cart nappi (Prestige käyttää buy-buttons elementtiä)
    this.addToCartButton = document.querySelector('buy-buttons button[type="submit"]');
    
    console.log('Checkbox löytyi:', !!this.engravingCheckbox);
    console.log('Form löytyi:', !!this.productForm);
    console.log('Add to Cart nappi löytyi:', !!this.addToCartButton);
    
    if (!this.engravingCheckbox || !this.productForm || !this.addToCartButton) {
      console.log('Ei löytynyt kaikkia elementtejä, lopetetaan');
      return;
    }
    
    this.init();
  }
  
  init() {
    console.log('ProductEngraving: Init käynnistyy');
    
    // Näytä/piilota tekstikenttä
    this.engravingCheckbox.addEventListener('change', () => {
      console.log('Checkbox muuttui:', this.engravingCheckbox.checked);
      if (this.engravingCheckbox.checked) {
        this.engravingTextWrapper.style.display = 'block';
      } else {
        this.engravingTextWrapper.style.display = 'none';
        this.engravingTextInput.value = '';
      }
    });
    
    // Kaappaa nappi ENNEN Prestige-teeman omaa logiikkaa
    this.addToCartButton.addEventListener('click', (e) => {
      console.log('Add to cart nappi klikattu!');
      this.handleAddToCart(e);
    }, true); // true = capture phase, käsitellään ennen muita
  }
  
  async handleAddToCart(e) {
    console.log('handleAddToCart kutsuttu, kaiverrus valittu:', this.engravingCheckbox.checked);
    
    // Jos kaiverrusta ei valittu, anna normaalin toiminnon mennä läpi
    if (!this.engravingCheckbox.checked) {
      console.log('Ei kaiverrusta, annetaan normaalin toiminnon mennä läpi');
      return;
    }
    
    // Tarkista että kaiverrusteksti on syötetty
    const engravingText = this.engravingTextInput.value.trim();
    if (!engravingText) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      // Näytä virheilmoitus Prestige-bannerin avulla
      this.showErrorBanner('Syötä kaiverrusteksti');
      return;
    }
    
    // Estetään normaali toiminto
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    console.log('Estetty normaali add to cart');
    
    const formData = new FormData(this.productForm);
    const mainProductId = formData.get('id');
    const quantity = formData.get('quantity') || 1;
    
    // DEBUG: Tulosta KAIKKI FormData sisältö
    console.log('=== FORMDATA SISÄLTÖ ===');
    for (let [key, value] of formData.entries()) {
      console.log(`${key}: "${value}"`);
    }
    console.log('=== FORMDATA LOPPU ===');
    
    // Hae tuotteen nimi ostoskoriin
    const productTitle = document.querySelector('.product-meta__title')?.textContent.trim() || 
                         document.querySelector('h1.product-title')?.textContent.trim() || 
                         document.querySelector('[itemprop="name"]')?.textContent.trim() ||
                         'Tuote';
    
    console.log('Main product ID:', mainProductId);
    console.log('Product title:', productTitle);
    console.log('Quantity:', quantity);
    console.log('Kaiverrusteksti:', engravingText);
    
    // Kerää main product data
    const mainProductData = {
      id: mainProductId,
      quantity: parseInt(quantity)
    };
    
    // Lisää propertyt jos on (SKIPAA TYHJÄT ARVOT)
    const properties = {};
    
    // TÄRKEÄÄ: Lue lahjapaketointi SUORAAN hidden inputista
    // (FormData ei välttämättä kerää sitä jos se on details-elementin sisällä)
    const giftPackagingInput = document.getElementById('gift-packaging-value');
    if (giftPackagingInput && giftPackagingInput.value.trim() !== '') {
      properties['Lahjapaketointi'] = giftPackagingInput.value.trim();
      console.log(`✓ Lahjapaketointi lisätty suoraan: "${giftPackagingInput.value}"`);
    }
    
    // Sitten kerää muut propertyt FormDatasta
    for (let [key, value] of formData.entries()) {
      if (key.startsWith('properties[')) {
        const propName = key.match(/properties\[(.*?)\]/)[1];
        console.log(`Property löydetty FormDatasta: ${propName} = "${value}" (tyhjä: ${!value || value.trim() === ''})`);
        // Lisää VAIN jos arvo ei ole tyhjä JA ei ole jo lisätty
        if (value && value.trim() !== '' && !properties[propName]) {
          properties[propName] = value;
          console.log(`✓ Lisätty FormDatasta: ${propName} = "${value}"`);
        } else if (properties[propName]) {
          console.log(`⊘ Skipattu (jo lisätty): ${propName}`);
        } else {
          console.log(`✗ Skipattu tyhjä property: ${propName}`);
        }
      }
    }
    
    if (Object.keys(properties).length > 0) {
      mainProductData.properties = properties;
    }
    
    console.log('Main product properties:', properties);
    
    const items = [
      mainProductData,
      {
        id: this.ENGRAVING_VARIANT_ID,
        quantity: parseInt(quantity),
        properties: {
          'Kaiverrusteksti': engravingText,
          'Kaiverrus tuotteelle': productTitle,
          '_Tuote': mainProductId,
          '_Linkitetty': 'kyllä'
        }
      }
    ];
    
    console.log('Items to add:', JSON.stringify(items, null, 2));
    
    // Lisää ostoskoriin
    await this.addToCart(items);
  }
  
  async addToCart(items) {
    console.log('addToCart kutsuttu');
    
    try {
      // Kerää sections jotka pitää päivittää (CartDrawer lisää oman section ID:nsä)
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { 
        bubbles: true, 
        detail: { sections: sectionsToBundle } 
      }));
      
      console.log('Sections to bundle:', sectionsToBundle);
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          items: items,
          sections: sectionsToBundle.join(',')
        })
      });
      
      console.log('Response status:', response.status);
      
      if (response.ok) {
        const data = await response.json();
        console.log('Lisäys onnistui:', data);
        
        // Hae päivitetty ostoskori
        const cartData = await (await fetch('/cart.js')).json();
        console.log('Cart data:', cartData);
        
        // Lisää sections data cart dataan
        cartData.sections = data.sections;
        
        // Lähetä cart:change event jotta Prestige avaa drawerin
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'variant:add',
            cart: cartData
          }
        }));
        
      } else {
        const errorData = await response.json();
        console.error('Virhe vastaus:', errorData);
        this.showErrorBanner(errorData.description || errorData.message || 'Virhe tuotteen lisäämisessä');
      }
    } catch (error) {
      console.error('Virhe ostoskoriin lisäämisessä:', error);
      this.showErrorBanner('Virhe tuotteen lisäämisessä ostoskoriin');
    }
  }
  
  /**
   * Näyttää virheilmoituksen Prestige-teeman banner-komponentilla
   */
  showErrorBanner(message) {
    // Etsi buy-buttons elementti
    const buyButtonsElement = document.querySelector('buy-buttons');
    
    if (!buyButtonsElement) {
      console.error('buy-buttons elementtiä ei löytynyt');
      return;
    }
    
    // Poista mahdollinen vanha banneri ensin
    const existingBanner = buyButtonsElement.querySelector('.banner');
    if (existingBanner) {
      existingBanner.remove();
    }
    
    // Luo virhebanneri
    const bannerElement = document.createRange().createContextualFragment(`
      <div class="banner banner--error" role="alert">
        ${message}
      </div>
    `).firstElementChild;
    
    // Lisää buy-buttons elementin alkuun
    buyButtonsElement.prepend(bannerElement);
    
    // Poista 2.5 sekunnin kuluttua
    setTimeout(() => {
      bannerElement.remove();
    }, 2500);
  }
}

// Käynnistä kun DOM on valmis
console.log('product-engraving-growly.js ladattu');
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    console.log('DOMContentLoaded event');
    new ProductEngraving();
  });
} else {
  console.log('DOM jo valmis, käynnistetään heti');
  new ProductEngraving();
}